<template>
  <div>
    <div class="row">
      <div class="col-12">
        <app-modal-progress-bar
          v-if="showExportModal"
          :progress="exportProgress"
          :label="exportModalLabel"
          :state="exportModalState"
        ></app-modal-progress-bar>
        <div
          style="min-height: 400px;"
          class="d-flex flex-column align-items-center justify-content-center"
        >
          <h2 style="text-align: center;" class="mb-0">
            {{
              errorOccured
                ? 'Report could not be downloaded.'
                : 'Campaign Report is downloading...'
            }}
          </h2>
          <p
            :style="
              errorOccured
                ? 'text-align: center; color: red'
                : 'text-align: center; '
            "
          >
            {{
              errorOccured
                ? 'An error occured while generating the PDF report.'
                : 'Once complete the PDF will be available in your downloads folder.'
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CampaignServices from '../../../services/campaigns';
import CampaignServiceV2 from '../../../services/V2/CampaignServiceV2';
import {format} from 'date-fns';
import AppModalProgressBar from '../../AppComponents/Loaders/AppModalProgressBar.vue';

export default {
  name: 'BaseCampaignComponentReportLayout',
  data() {
    return {
      errorOccured: false,
      showExportModal: false,
      exportProgress: 0,
      exportModalState: 'loading',
      exportModalLabel: 'Exporting PDF Report...',
    };
  },
  components: {
    AppModalProgressBar,
  },
  methods: {
    async downloadPdf() {
      if (this.$route.params.campaignId) {
        this.exportModalLabel = 'Exporting PDF Report...';
        try {
          // Verify access
          await CampaignServices.getCampaignPublic(
            this.$route.params.campaignId,
            this.$route.params.token
          );

          this.exportProgress = 0;
          this.showExportModal = true;

          setTimeout(() => {
            this.exportProgress = 20;
          }, 250);

          setTimeout(() => {
            this.exportProgress = 70;
          }, 2000);

          let interval = setInterval(() => {
            if (this.exportProgress < 95) {
              this.exportProgress = this.exportProgress + 1;
            }
          }, 1000);

          // Download PDF
          const response = await CampaignServiceV2.downloadPdfReport(
            this.$route.params.campaignId,
            {
              responseType: 'blob',
            }
          );
          this.exportProgress = 100;
          this.exportModalLabel = 'Campaign PDF generated!';

          const filename = response.headers['acquire-filename'];

          const pdfBlob = new Blob([response.data], {type: 'application/pdf'});

          const downloadUrl = window.URL.createObjectURL(pdfBlob);
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.download = filename; // Set the file name
          document.body.appendChild(link);
          link.click();

          // Clean up the URL object and remove the link element
          window.URL.revokeObjectURL(downloadUrl);
          document.body.removeChild(link);
        } catch (error) {
          this.errorOccured = true;
          console.error('Error fetching campaign:', error);
        }
      }
    },
  },
  mounted() {
    this.downloadPdf();
  },
};
</script>

<style scoped>
.report__parent-container,
.report__parent-container p {
  font-family: 'DM Sans', system-ui !important;
}

.report__report-type-header-label {
  color: black;
  text-align: center;
  font-size: 20px;
  font-weight: 700;
}

.report__report-container-header-logo {
  max-height: 40px;
  object-fit: cover;
}
</style>
